import { render } from "./sticky_advance.vue?vue&type=template&id=5b283743"
import script from "./sticky_advance.vue?vue&type=script&lang=js"
export * from "./sticky_advance.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__